import { MARKETING_EMBED_NAV_CSS_ID } from './MarketingNav.constants';

export function getWindowLocation(): Pick<Location, 'pathname' | 'search'> {
  return window.location;
}

export function getMarketingEmbedNavLocale(lang: string) {
  switch (lang) {
    case 'pt':
      return 'pt_BR';
    case 'zh-cn':
      return 'zh_CN';
    case 'zh':
    case 'zh-tw':
      return 'zh_TW';
    default:
      return lang;
  }
}

export function getInitialScriptLoading() {
  return !(window as any).HSGlobalNav?.load;
}

export function getInitialCssLoading() {
  return !document.getElementById(MARKETING_EMBED_NAV_CSS_ID);
}
